export const Operator = ({
  className,
  strokeColor = '#fff',
}: {
  className?: string
  strokeColor?: string
}) => (
  <svg
    className={className}
    height='33'
    viewBox='0 0 32 33'
    width='32'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none' fillRule='evenodd' transform='translate(0 .5)'>
      <path d='M0 0h32v32H0z' />
      <rect
        height={9}
        rx={2.667}
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        width={6}
        x={4}
        y={15.875}
      />
      <rect
        height={9}
        rx={2.667}
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        width={6}
        x={22}
        y={15.875}
      />
      <path
        d='M4 18.875v-4.5c0-6.627 5.373-12 12-12s12 5.373 12 12v4.5M25 24.875c0 2.485-3.03 4.5-8 4.5'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
      />
    </g>
  </svg>
)
